import { render, staticRenderFns } from "./MasterGroupClassSalary.vue?vue&type=template&id=28e7b69e"
import script from "./MasterGroupClassSalary.vue?vue&type=script&lang=js"
export * from "./MasterGroupClassSalary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports